import { IndependentService, IndependentStudentItem } from "@/services/independent";
import { ActionTree } from "vuex";
import { StudentState } from "../../room/interface";
import { StudyMode } from "../interfaces";
import { TeacherTeachingState } from "./state";
import { Logger } from "@/utils/logger";
import { defineVuexName, MODULES, vuexName } from "@/store/utils";

const actions: ActionTree<TeacherTeachingState, any> = {
  async [defineVuexName(MODULES.TEACHER_TEACHING.DISPATCHES.TOGGLE_INDEPENDENT_MODE)]({ commit, rootGetters }) {
    const isIndependentMode = rootGetters[vuexName(MODULES.CLASS_TEACHING.GETTERS.GET_IS_INDEPENDENT_MODE)];
    let currentUnit: null | number = null;
    let currentLesson: null | number = null;
    try {
      if (isIndependentMode) {
        //* end the independent mode
        currentUnit = rootGetters[vuexName(MODULES.CLASS_TEACHING.GETTERS.GET_INDEPENDENT_MODE_CURRENT_UNIT)];
        currentLesson = rootGetters[vuexName(MODULES.CLASS_TEACHING.GETTERS.GET_INDEPENDENT_MODE_CURRENT_LESSON)];
        if (!currentUnit || !currentLesson) return;
        await IndependentService.toggleIndependentMode(currentUnit, currentLesson);
        commit(vuexName(MODULES.TEACHER_TEACHING.COMMITS.SET_INDEPENDENT_LIST_STUDENT_ITEMS, false), null);
        commit(vuexName(MODULES.CLASS_TEACHING.COMMITS.SET_INDEPENDENT_MODE_CURRENT_UNIT), null, { root: true });
        commit(vuexName(MODULES.CLASS_TEACHING.COMMITS.SET_INDEPENDENT_MODE_CURRENT_LESSON), null, { root: true });
      } else {
        //* start the independent mode
        const firstBlockItemId: string | undefined = rootGetters[vuexName(MODULES.LESSON.GETTERS.GET_LIST_READER_ITEMS_OF_CURRENT_EXPOSURE)]?.[0]?.id;
        currentUnit = rootGetters[vuexName(MODULES.TEACHER_ROOM.GETTERS.GET_CURRENT_UNIT)];
        currentLesson = rootGetters[vuexName(MODULES.TEACHER_ROOM.GETTERS.GET_CURRENT_LESSON)];
        if (!currentUnit || !currentLesson) return;
        if (firstBlockItemId) {
          await IndependentService.toggleIndependentMode(currentUnit, currentLesson, firstBlockItemId);
          const students: StudentState[] = rootGetters[vuexName(MODULES.TEACHER_ROOM.GETTERS.GET_STUDENTS)];
          const payload: IndependentStudentItem[] = students.map((student) => ({ studentId: student.id, currentItemId: firstBlockItemId }));
          commit(vuexName(MODULES.TEACHER_TEACHING.COMMITS.SET_INDEPENDENT_LIST_STUDENT_ITEMS, false), payload);
          commit(vuexName(MODULES.CLASS_TEACHING.COMMITS.SET_INDEPENDENT_MODE_CURRENT_UNIT), currentUnit, { root: true });
          commit(vuexName(MODULES.CLASS_TEACHING.COMMITS.SET_INDEPENDENT_MODE_CURRENT_LESSON), currentLesson, { root: true });
        }
      }
      commit(vuexName(MODULES.CLASS_TEACHING.COMMITS.SET_MODE), isIndependentMode ? StudyMode.Normal : StudyMode.Independent, { root: true });
    } catch (error) {
      Logger.error(error);
    }
  },
  //helperToggleIndependentMode
  [defineVuexName(MODULES.TEACHER_TEACHING.DISPATCHES.HELPER_TOGGLE_INDEPENDENT_MODE)]({ commit, rootGetters }, firstItemId: string | null) {
    if (!firstItemId) {
      commit(vuexName(MODULES.TEACHER_TEACHING.COMMITS.SET_INDEPENDENT_LIST_STUDENT_ITEMS, false), null);
      commit(vuexName(MODULES.CLASS_TEACHING.COMMITS.SET_MODE), StudyMode.Normal, { root: true });
      return;
    }
    const students: StudentState[] = rootGetters[vuexName(MODULES.TEACHER_ROOM.GETTERS.GET_STUDENTS)];
    const payload: IndependentStudentItem[] = students.map((student) => ({ studentId: student.id, currentItemId: firstItemId }));
    commit(vuexName(MODULES.TEACHER_TEACHING.COMMITS.SET_INDEPENDENT_LIST_STUDENT_ITEMS, false), payload);
    commit(vuexName(MODULES.CLASS_TEACHING.COMMITS.SET_MODE), StudyMode.Independent, { root: true });
  },
};

export default actions;
